<template>
    <EChart
        :options="chartOptions"
        card
        :header="$t('thermalMapCategoriesShops')"
        overlay
        :loading="loading"
        :error="request.getError()"
    >

        <template #nav>
            <div class="d-flex gap-3">
                <DropdownFilter v-model="currentChart" :items="['impressions', 'clicks']" :prefix="`${$t('type')}: `" :disabled="loading" />
            </div>
        </template>

    </EChart>
</template>



<script>
    import DropdownFilter from '@/components/common/DropdownFilter.vue';
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'CategoryHeatmap',
        components: {
            DropdownFilter,
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChartImpressions: this.$req('space/CategoryImpressionsHeatmap'),
                requestChartClicks: this.$req('space/CategoryClicksHeatmap'),
                currentChart: 'impressions',
            };
        },
        computed: {
            request() {
                if (this.currentChart === 'impressions') return this.requestChartImpressions;
                if (this.currentChart === 'clicks') return this.requestChartClicks;
                return null;
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const { startDate, endDate } = this.timeRange;
                const requestParams = { startDate, endDate };
                return { urlParams, requestParams };
            },
            loadingFilters() {
                return false;
            },
            loading() {
                return this.request.getLoading() || this.loadingFilters;
            },
            // surowe dane z API
            chartData() {
                return this.request.getData() || [];
            },
            // sklepy → oś X
            shops() {
                if (!this.chartData[0]) return [];
                const baseShops = this.chartData[0].slice(1);
                return [...baseShops, 'Suma'];
            },
            // kategorie → oś Y
            categories() {
                return this.chartData.slice(1).map(row => row[0]);
            },
            // dane [xIndex, yIndex, wartość]
            heatmapData() {
                if (!this.chartData.length) return [];

                const rows = this.chartData.slice(1);
                const shopCount = this.chartData[0].slice(1).length;

                // 1) zwykłe komórki
                const baseData = rows.flatMap((row, y) =>
                    row.slice(1).map((val, x) => ({
                        value: [x, y, val],
                    }))
                );

                // 2) komórki „Suma” – obiekty z override style
                const sumData = rows.map((row, y) => {
                    const sum = row.slice(1).reduce((s, v) => s + v, 0);
                    return {
                        value: [shopCount, y, sum],
                        itemStyle: { color: 'lightgray' },
                        label: { fontWeight: 'bold', color: 'black' },
                    };
                });

                return baseData.concat(sumData);
            },
            // opcje ECharts
            chartOptions() {
                if (!this.heatmapData.length) {
                    return {
                        xAxis: [{ type: 'category', data: [] }],
                        yAxis: [{ type: 'category', data: [] }],
                        series: [],
                    };
                }
                return {
                    legend: { show: false },
                    visualMap: { show: false },
                    xAxis: [
                        {
                            position: 'top',
                            type: 'category',
                            data: this.shops,
                            splitArea: { show: true },
                        },
                    ],
                    yAxis: [
                        {
                            type: 'category',
                            data: this.categories,
                            splitArea: { show: true },
                        },
                    ],
                    series: [
                        {
                            name: this.$t(this.currentChart),
                            type: 'heatmap',
                            data: this.heatmapData,
                            label: { show: true },
                        },
                    ],
                };
            },
        },
        watch: {
            spaceId() {
                this.resetFilters();
            },
            apiParams: {
                immediate: true,
                handler(newVal, oldVal) {
                    if (JSON.stringify(newVal || {}) !== JSON.stringify(oldVal || {})) {
                        this.loadData();
                    }
                },
            },
            currentChart: {
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                if (!this.loadingFilters) {
                    this.resetData();
                    this.fetchData();
                }
            },
            resetData() {
                this.request.abortAll();
                this.request.resetAll();
            },
            fetchData() {
                this.request.get(this.apiParams);
            },
            resetFilters() {
                this.currentChart = 'impressions';
            },
        },
        created() {
            this.parentComponent.$on('resetFilters', this.resetFilters);
        },
        beforeDestroy() {
            this.parentComponent.$off('resetFilters', this.resetFilters);
        },
    };
</script>
